window.theme = window.theme || {};
window.Shopify = window.Shopify || {};
theme.GeoLocation = (function() {

    function init() {
        var sessionCountry = sessionStorage.getItem('country_code2');
        var sessionShopifyCountry = sessionStorage.getItem('shopify_country_code2');

        if (!sessionCountry) {
            // console.log('Fetching geolocation data from Crossrope');
            fetch('https://www.crossrope.com/browsing_context_suggestions.json')
                .then((response) => response.json())
                .then((data) => {
                    var country = data.detected_values.country.handle;
                    handleRedirects(country);
                    hideGlobalEForCanada(country);
                    sessionStorage.setItem('country_code2', country);
                });
        } else {
            handleRedirects(sessionCountry);
            hideGlobalEForCanada(sessionCountry);
        }

        if (!sessionShopifyCountry) {
            // console.log('Setting initial Shopify country in session storage:', Shopify.country);
            sessionStorage.setItem('shopify_country_code2', Shopify.country);
        }
    }

    function handleRedirects(country) {
        var redirectUrl = '',
            redirectPathname = null;
        if(country && country_redirect) {
            if(isEu(country) && country_redirect.hasOwnProperty('EU')) {
                redirectPathname = country_redirect['EU'];
            } else if(country == 'CA' && country_redirect.hasOwnProperty('CA')) {
                redirectPathname = country_redirect['CA'];
            } else if(country == 'US' && country_redirect.hasOwnProperty('US')) {
                redirectPathname = country_redirect['US'];
            } else {
              if ((country == 'US') || (country == 'CA') || (isEu(country))  ) {
                // Do Nothing
              } else if (country_redirect.hasOwnProperty('US')) {
                redirectPathname = country_redirect['US'];
              } else if(country_redirect.hasOwnProperty(country)) {
                redirectPathname = country_redirect[country];
              }
            }
        }
        if(redirectPathname && redirectPathname != '') {
            console.log('country',country);
            try {
                const redirectPathnameUrl = new URL(redirectPathname);
                if(redirectPathnameUrl && redirectPathnameUrl.origin) {
                    if(window.location.origin !== redirectPathnameUrl.origin) {
                        window.location.replace(redirectPathname);
                        return false;
                    }
                }
            } catch (e) {

            }
            if(window.location.pathname == redirectPathname) {
                return false;
            }
            redirectUrl = window.location.origin + redirectPathname + window.location.search;
            window.location.replace(redirectUrl);
        }


    }

    function hideGlobalEForCanada(country) {
        var geFlagIcons = document.querySelectorAll(".ge-flag-show")
        if(isCanada(country)) {
            setTimeout(function() {
                if( geFlagIcons.length > 0 ) {
                    console.log("yes")
                    console.log(geFlagIcons)
                    for (var i = 0; i < geFlagIcons.length; i++) {
                        geFlagIcons[i].remove()
                    }
    
                } else {
                    hideGlobalEForCanada();
                }
            }, 300);
        }
    }

    function isEu(country) {
        var eu_redirected_countries = ["AT","BE","BG","HR","CY","CZ","DK","EE","FI","FR","DE","GR","HU","IE","IT","LV","LT","LU","MT","NL","PL","PT","RO","SK","SI","ES","SE","GB"];
        return eu_redirected_countries.indexOf(country) > -1;
    }

    function isCanada(country) {
        if( country == "CA" ) {
            return true
        } else {
            return false
        }
    }

    function handleGeoResponse(json) {
        //ip = json.ip;
        country = json.country_code2;
    }

    function getCountry() {
        // console.log(`Getting country from session storage or Shopify object`);
        var sessionCountry = sessionStorage.getItem('country_code2') || Shopify.country;
        var sessionShopifyCountry = sessionStorage.getItem('shopify_country_code2');
        // console.log('Shopify.country',Shopify.country);
        // console.log('sessionCountry',sessionCountry);
        // console.log('sessionShopifyCountry',sessionShopifyCountry);

        if (Shopify.country !== sessionShopifyCountry && sessionShopifyCountry) {
            // console.log(`Updating session storage with new Shopify.country value: ${Shopify.country}`);
            sessionStorage.setItem('shopify_country_code2', Shopify.country);
            sessionStorage.setItem('country_code2', Shopify.country);
            sessionCountry = Shopify.country;
        }

        if( typeof sessionCountry !== "undefined" ) {
            return sessionCountry;
        }
    }

    return {
        init: init,
        country: getCountry,
        isEu: isEu,
        isCanada: isCanada
    };
})();
theme.GeoLocation.init();
